import { render, staticRenderFns } from "./Programma.vue?vue&type=template&id=079b5a73&scoped=true&"
import script from "./Programma.vue?vue&type=script&lang=js&"
export * from "./Programma.vue?vue&type=script&lang=js&"
import style0 from "./Programma.vue?vue&type=style&index=0&id=079b5a73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b5a73",
  null
  
)

export default component.exports